import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/common/Analytics/CustomButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/ListingBanner/BlogsListingBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SectionCard/SectionCard.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/BlogsListSection/BlogsListSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/Breadcrumbs/BreadCrumbs.tsx");
